module.exports = __webpack_public_path__ + "img/92.f2109b5d.jpg";